import { useEffect } from "react";
import classNames from "classnames";
import { makeStyles } from "@mui/styles";
import {
  LessonIcon,
  FreeplayIcon,
  GuidedReadingIcon,
} from "components/SVGs/HomeIcons";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { useTranslation } from "react-i18next";
import {
  ITag,
  moeViewSet,
  searchBySet,
  searchSet,
  sectionSet,
  selectSearchBy,
  selectSection,
} from "features/content";
import SectionsSkeleton from "./SectionsSkeleton";
import { LessonTypes } from "features/common/Interfaces";

const useStyles = makeStyles({
  subMenu: {
    userSelect: "none",
    display: "flex",
    alignItems: "center",
    listStyle: "none",
    padding: "0 25px",
    background: "rgba(255 255 255)",
    margin: 0,
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
  },
  tab: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "rgba(111, 117, 138, 1)",
    fontSize: "0.9rem",
    padding: "0 25px",
    cursor: "pointer",
    lineHeight: "60px",
    "&:hover": {
      fontWeight: "bold",
    },
    "& svg": {
      margin: "0 10px",
      color: "rgba(165, 170, 182, 1)",
    },
  },
  selectedTab: {
    boxShadow: "inset 0 -2px 0 rgba(111, 117, 138, 1)",
    fontWeight: "bold",
    padding: "0 25px",
    lineHeight: "60px",
    cursor: "default",
    "& svg": {
      color: "rgba(106, 112, 129, 1)",
    },
  },
});

const icons = {
  LESSON: <LessonIcon sx={{ fontSize: "1.5rem" }} />,
  FREEPLAY: <FreeplayIcon />,
  GUIDED_READING: <GuidedReadingIcon />,
};
interface ISectionsProps {
  isLoading?: boolean;
}
function Sections({ isLoading = true }: ISectionsProps) {
  const { t, i18n } = useTranslation();
  const currentSection = useAppSelector(selectSection);
  const searchBy = useAppSelector(selectSearchBy);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(sectionSet(LessonTypes.LESSON));
  }, []);

  const selectSectionHandler = (section: LessonTypes) => {
    dispatch(sectionSet(section));
    dispatch(moeViewSet(false));
    dispatch(searchSet(searchBy?.value === "name" ? "" : ([] as ITag[])));
    dispatch(searchBySet({ label: t("Name"), value: "name" }));
  };

  const classes = useStyles();

  return (
    <ul className={classes.subMenu} style={{ direction: i18n.dir() }}>
      {isLoading ? (
        <SectionsSkeleton />
      ) : (
        (Object.keys(LessonTypes) as LessonTypes[]).map((section) => (
          <li
            key={section}
            className={classNames(
              classes.tab,
              currentSection === section ? classes.selectedTab : null
            )}
            onClick={() => selectSectionHandler(section)}
          >
            {icons[section]}
            <span>{t(section)}</span>
          </li>
        ))
      )}
    </ul>
  );
}

export default Sections;
